import { useLazyQuery } from 'data-fetching-client';
import { useEffect } from 'react';
import { GET_SMART_COPY_WARNINGS_COUNT, GET_SMART_COPY_WARNINGS_FILE } from '../queries';
import { useSmartCopyProgress } from './useSmartCopyProgress';
export const useSmartCopyWarnings = knowledgeBaseId => {
  const {
    state
  } = useSmartCopyProgress(knowledgeBaseId);
  const [fetchCount, warningsCount] = useLazyQuery(GET_SMART_COPY_WARNINGS_COUNT, {
    variables: {
      knowledgeBaseId
    }
  });
  const [fetchFile, warningsFile] = useLazyQuery(GET_SMART_COPY_WARNINGS_FILE, {
    variables: {
      knowledgeBaseId
    }
  });
  useEffect(() => {
    if (state === 'CANCELLED' || state === 'COMPLETED') {
      setTimeout(() => {
        fetchCount();
        fetchFile();
      }, 2000);
    }
  }, [fetchCount, fetchFile, state]);
  if (warningsCount.error || warningsFile.error) {
    return {
      isFetched: true,
      count: 0
    };
  }
  if (warningsCount.data && warningsFile.data) {
    var _warningsFile$data$sm;
    return {
      isFetched: true,
      count: warningsCount.data.smartCopyWarningsCount,
      url: (_warningsFile$data$sm = warningsFile.data.smartCopyWarningsFile.url) !== null && _warningsFile$data$sm !== void 0 ? _warningsFile$data$sm : undefined
    };
  }
  return {
    isFetched: false
  };
};